import React from "react";
import "./gameStatusModal.css"; // Import the CSS file for styles
import { GameStatusForSchedule } from "../../../../constants/enum";

const GameStatusModal = (props) => {
  return (
    <div className={`overlay ${props.isVisible ? "visible" : "hidden"}`} onClick={props.onBackdropPress}>
      <div className="modalContent" onClick={(e) => e.stopPropagation()}>
        <h2 className="heading">SELECT GAME STATUS</h2>

        {Object.values(GameStatusForSchedule).map((status, index) => (
          <button onClick={() => props.selectGameStatus(status)} key={index} className="forfeitBtn">
            {status}
          </button>
        ))}
      </div>
    </div>
  );
};

export default GameStatusModal;
